import React from "react";
import { Row } from "react-bootstrap";
import RetreatItem from "./retreat";

const RetreatList = ({ retreats }) => {
  // Sort retreats by title (handles 1-, 2-, etc. so user can order via prefix)
  const sortedRetreats = retreats
    ? [...retreats].sort((a, b) => {
        const titleA = a.title || "";
        const titleB = b.title || "";
        return titleA.localeCompare(titleB, undefined, {
          numeric: true,
          sensitivity: "base",
        });
      })
    : [];

  // Strip the numeric prefix (e.g., "1-", "2-") from retreat titles
  const stripPrefix = (title) => {
    if (!title) return title;
    return title.replace(/^\d+-/, "");
  };

  return (
    <Row className="justify-content-center">
      {sortedRetreats.map((retreat) => {
        const retreatWithStrippedTitle = {
          ...retreat,
          title: stripPrefix(retreat.title),
        };
        return (
          <RetreatItem key={retreat._id} retreat={retreatWithStrippedTitle} />
        );
      })}
    </Row>
  );
};

export default RetreatList;
